import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import Rsvp from "@/pages/Rsvp";
import MyRsvp from "@/pages/MyRsvp";
import HostLogin from "@/pages/HostLogin";
import HostDashboard from "@/pages/HostDashboard";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/rsvp" element={<Rsvp />} />
      <Route path="/my-rsvp" element={<MyRsvp />} />
      <Route path="/host/login" element={<HostLogin />} />
      <Route path="/host" element={<HostDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
